/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as TermsRouteImport } from "./routes/terms";
import { Route as PrivacyRouteImport } from "./routes/privacy";
import { Route as InstallRouteImport } from "./routes/install";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as ShareTokenRouteImport } from "./routes/share.$token";
import { Route as AuthenticatedSettingsRouteImport } from "./routes/_authenticated/settings";
import { Route as AuthenticatedStatsIndexRouteImport } from "./routes/_authenticated/stats/index";
import { Route as AuthenticatedPlayersIndexRouteImport } from "./routes/_authenticated/players/index";
import { Route as AuthenticatedGamesIndexRouteImport } from "./routes/_authenticated/games/index";
import { Route as AuthenticatedPlayersProfileIdRouteImport } from "./routes/_authenticated/players/$profileId";
import { Route as AuthenticatedMatchesIdRouteImport } from "./routes/_authenticated/matches/$id";
import { Route as AuthenticatedGamesSlugRouteImport } from "./routes/_authenticated/games/$slug";
import { Route as AuthenticatedGamesSlugNewRouteImport } from "./routes/_authenticated/games/$slug_.new";

const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any);
const InstallRoute = InstallRouteImport.update({
  id: "/install",
  path: "/install",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: "/share/$token",
  path: "/share/$token",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedStatsIndexRoute = AuthenticatedStatsIndexRouteImport.update({
  id: "/stats/",
  path: "/stats/",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlayersIndexRoute =
  AuthenticatedPlayersIndexRouteImport.update({
    id: "/players/",
    path: "/players/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedGamesIndexRoute = AuthenticatedGamesIndexRouteImport.update({
  id: "/games/",
  path: "/games/",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlayersProfileIdRoute =
  AuthenticatedPlayersProfileIdRouteImport.update({
    id: "/players/$profileId",
    path: "/players/$profileId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedMatchesIdRoute = AuthenticatedMatchesIdRouteImport.update({
  id: "/matches/$id",
  path: "/matches/$id",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedGamesSlugRoute = AuthenticatedGamesSlugRouteImport.update({
  id: "/games/$slug",
  path: "/games/$slug",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedGamesSlugNewRoute =
  AuthenticatedGamesSlugNewRouteImport.update({
    id: "/games/$slug_/new",
    path: "/games/$slug/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/install": typeof InstallRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/settings": typeof AuthenticatedSettingsRoute;
  "/share/$token": typeof ShareTokenRoute;
  "/games/$slug": typeof AuthenticatedGamesSlugRoute;
  "/matches/$id": typeof AuthenticatedMatchesIdRoute;
  "/players/$profileId": typeof AuthenticatedPlayersProfileIdRoute;
  "/games/": typeof AuthenticatedGamesIndexRoute;
  "/players/": typeof AuthenticatedPlayersIndexRoute;
  "/stats/": typeof AuthenticatedStatsIndexRoute;
  "/games/$slug/new": typeof AuthenticatedGamesSlugNewRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/install": typeof InstallRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/settings": typeof AuthenticatedSettingsRoute;
  "/share/$token": typeof ShareTokenRoute;
  "/games/$slug": typeof AuthenticatedGamesSlugRoute;
  "/matches/$id": typeof AuthenticatedMatchesIdRoute;
  "/players/$profileId": typeof AuthenticatedPlayersProfileIdRoute;
  "/games": typeof AuthenticatedGamesIndexRoute;
  "/players": typeof AuthenticatedPlayersIndexRoute;
  "/stats": typeof AuthenticatedStatsIndexRoute;
  "/games/$slug/new": typeof AuthenticatedGamesSlugNewRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/install": typeof InstallRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/_authenticated/settings": typeof AuthenticatedSettingsRoute;
  "/share/$token": typeof ShareTokenRoute;
  "/_authenticated/games/$slug": typeof AuthenticatedGamesSlugRoute;
  "/_authenticated/matches/$id": typeof AuthenticatedMatchesIdRoute;
  "/_authenticated/players/$profileId": typeof AuthenticatedPlayersProfileIdRoute;
  "/_authenticated/games/": typeof AuthenticatedGamesIndexRoute;
  "/_authenticated/players/": typeof AuthenticatedPlayersIndexRoute;
  "/_authenticated/stats/": typeof AuthenticatedStatsIndexRoute;
  "/_authenticated/games/$slug_/new": typeof AuthenticatedGamesSlugNewRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/install"
    | "/privacy"
    | "/terms"
    | "/settings"
    | "/share/$token"
    | "/games/$slug"
    | "/matches/$id"
    | "/players/$profileId"
    | "/games/"
    | "/players/"
    | "/stats/"
    | "/games/$slug/new";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/install"
    | "/privacy"
    | "/terms"
    | "/settings"
    | "/share/$token"
    | "/games/$slug"
    | "/matches/$id"
    | "/players/$profileId"
    | "/games"
    | "/players"
    | "/stats"
    | "/games/$slug/new";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/install"
    | "/privacy"
    | "/terms"
    | "/_authenticated/settings"
    | "/share/$token"
    | "/_authenticated/games/$slug"
    | "/_authenticated/matches/$id"
    | "/_authenticated/players/$profileId"
    | "/_authenticated/games/"
    | "/_authenticated/players/"
    | "/_authenticated/stats/"
    | "/_authenticated/games/$slug_/new";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  InstallRoute: typeof InstallRoute;
  PrivacyRoute: typeof PrivacyRoute;
  TermsRoute: typeof TermsRoute;
  ShareTokenRoute: typeof ShareTokenRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/terms": {
      id: "/terms";
      path: "/terms";
      fullPath: "/terms";
      preLoaderRoute: typeof TermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacy": {
      id: "/privacy";
      path: "/privacy";
      fullPath: "/privacy";
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/install": {
      id: "/install";
      path: "/install";
      fullPath: "/install";
      preLoaderRoute: typeof InstallRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/share/$token": {
      id: "/share/$token";
      path: "/share/$token";
      fullPath: "/share/$token";
      preLoaderRoute: typeof ShareTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/settings": {
      id: "/_authenticated/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/stats/": {
      id: "/_authenticated/stats/";
      path: "/stats";
      fullPath: "/stats/";
      preLoaderRoute: typeof AuthenticatedStatsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/players/": {
      id: "/_authenticated/players/";
      path: "/players";
      fullPath: "/players/";
      preLoaderRoute: typeof AuthenticatedPlayersIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/games/": {
      id: "/_authenticated/games/";
      path: "/games";
      fullPath: "/games/";
      preLoaderRoute: typeof AuthenticatedGamesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/players/$profileId": {
      id: "/_authenticated/players/$profileId";
      path: "/players/$profileId";
      fullPath: "/players/$profileId";
      preLoaderRoute: typeof AuthenticatedPlayersProfileIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/matches/$id": {
      id: "/_authenticated/matches/$id";
      path: "/matches/$id";
      fullPath: "/matches/$id";
      preLoaderRoute: typeof AuthenticatedMatchesIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/games/$slug": {
      id: "/_authenticated/games/$slug";
      path: "/games/$slug";
      fullPath: "/games/$slug";
      preLoaderRoute: typeof AuthenticatedGamesSlugRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/games/$slug_/new": {
      id: "/_authenticated/games/$slug_/new";
      path: "/games/$slug/new";
      fullPath: "/games/$slug/new";
      preLoaderRoute: typeof AuthenticatedGamesSlugNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute;
  AuthenticatedGamesSlugRoute: typeof AuthenticatedGamesSlugRoute;
  AuthenticatedMatchesIdRoute: typeof AuthenticatedMatchesIdRoute;
  AuthenticatedPlayersProfileIdRoute: typeof AuthenticatedPlayersProfileIdRoute;
  AuthenticatedGamesIndexRoute: typeof AuthenticatedGamesIndexRoute;
  AuthenticatedPlayersIndexRoute: typeof AuthenticatedPlayersIndexRoute;
  AuthenticatedStatsIndexRoute: typeof AuthenticatedStatsIndexRoute;
  AuthenticatedGamesSlugNewRoute: typeof AuthenticatedGamesSlugNewRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedGamesSlugRoute: AuthenticatedGamesSlugRoute,
  AuthenticatedMatchesIdRoute: AuthenticatedMatchesIdRoute,
  AuthenticatedPlayersProfileIdRoute: AuthenticatedPlayersProfileIdRoute,
  AuthenticatedGamesIndexRoute: AuthenticatedGamesIndexRoute,
  AuthenticatedPlayersIndexRoute: AuthenticatedPlayersIndexRoute,
  AuthenticatedStatsIndexRoute: AuthenticatedStatsIndexRoute,
  AuthenticatedGamesSlugNewRoute: AuthenticatedGamesSlugNewRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  InstallRoute: InstallRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  ShareTokenRoute: ShareTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
